import script from "./CustomClickableInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomClickableInput.vue?vue&type=script&setup=true&lang=js"

import "./CustomClickableInput.vue?vue&type=style&index=0&id=306dbbe8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-306dbbe8"]])

export default __exports__